import { isNumber } from 'lodash';
import { BigNumber } from 'bignumber.js';
import React from 'react';
import { currencyFormat } from 'utils/contract/common-function';
import { toast } from 'react-toastify';

const DEFAULT_RATIO = 16;
export const rem = (pxValue: number | TemplateStringsArray | string) => {
  if (Array.isArray(pxValue)) {
    pxValue = pxValue[0];
  }

  pxValue = parseInt((pxValue as string) + '');

  return `${pxValue / DEFAULT_RATIO}rem`;
};

export const LogError = text => {
  //console.log(`%c${text}`, 'color: red');
};

export const LogObject = (text, obj) => {
  //console.log(`%c${text}`, 'color: red', obj);
};

export const LogString = text => {
  //console.log(`%c${text}`, `color: #3EE9E8`);
};

export function formatBigNumber(
  amount: BigNumber,
  digits: number,
  formatByCurrency = false,
) {
  if (formatByCurrency) {
    return currencyFormat(amount.dp(digits, BigNumber.ROUND_DOWN).toString());
  }
  return amount.dp(digits, BigNumber.ROUND_DOWN).toString();
}

export function handleNumericInput(fn: (n?: BigNumber) => void) {
  return (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/,/g, '');
    const amount = value !== '' ? new BigNumber(value) : undefined;
    fn(amount);
  };
}

export const formatInputNumber = (
  numberString: string | number,
  decimal = 5,
): string => {
  numberString = (numberString as string) + '';

  numberString = numberString.replace(/[\uff01-\uff6e\uff61]/g, function (ch) {
    return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
  });
  const charCode = numberString.charCodeAt(numberString.length - 1);
  if (charCode === 12290 || charCode === 129) {
    numberString = numberString.replace(/.$/, '.');
  }
  if (decimal === 0) {
    numberString = numberString.replace(/[^0-9]/g, '');
  } else {
    numberString = numberString.replace(/[^0-9.]/g, '');
  }
  if (numberString.length === 0) return '';
  const index = numberString.indexOf('.');
  if (index > 0) {
    let string = numberString.slice(index + 1);
    string = string.replace(/[^0-9]/g, '');
    const value = numberString.slice(0, index);
    if (string.length > decimal) {
      string = string.slice(0, decimal);
    }
    numberString = value + '.' + string;
  } else if (index === 0) {
    let string = numberString.slice(index + 1);
    string = string.replace(/[^0-9]/g, '');
    const value = '0';
    if (string.length > decimal) {
      string = string.slice(0, decimal);
    }
    numberString = value + '.' + string;
  } else {
    numberString = parseFloat(numberString);
  }

  if (isNumber(numberString)) {
    return `${numberString}`;
  }
  return numberString;
};

export const middleTruncate = (str: string, length: number): string => {
  const subLength = Math.floor(length / 2);
  const s1 = str.substring(0, subLength);
  const s2 = str.substring(str.length - subLength);
  return s1 + '...' + s2;
};

export const notifySuccess = message => {
  toast.success(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
  });
};

export const notifyError = message => {
  toast.error(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
  });
};

export function merge(a: any, b: any, key: string) {
  function x(a) {
    a.forEach(function (b) {
      if (!(b[key] in obj)) {
        obj[b[key]] = obj[b[key]] || {};
        // @ts-ignore
        array.push(obj[b[key]]);
      }
      Object.keys(b).forEach(function (k) {
        obj[b[key]][k] = b[k];
      });
    });
  }

  const array = [],
    obj = {};

  x(a);
  x(b);
  return array;
}
